import { render, staticRenderFns } from "./CreateBasicInfo.vue?vue&type=template&id=1619021a&"
import script from "./CreateBasicInfo.vue?vue&type=script&lang=ts&"
export * from "./CreateBasicInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports